/* istanbul ignore file */
import { PageLoadingIndicator } from '@applications/billing/components/page-loading-indicator';
import * as Loadable from 'react-loadable';

const PaymentOptionLazy = Loadable({
    loader: () => import(/* webpackChunkName: "payment-option" */'./index'),
    loading: PageLoadingIndicator,
});

export default PaymentOptionLazy;
